<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:40:08
 * @LastEditors: Ximen
 * @LastEditTime: 2021-03-31 14:52:52
-->
<template>
  <div class="sale-box">
    <a-card :style="index==3?'margin-right:0':''"
    v-for="(item,index) in list" :key="item.id"
    :class="isSelected==index?'selected':'box'"
    @click="chooseLevel(index)">
      <p class="title">{{item.name}}</p>
      <div class="img-box"></div>
      <p class="price">￥ {{item.value}}</p>
    </a-card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import commonApi from '@/api/common';

// const productList: string[];

export default defineComponent({
  name: 'RenewalUpgrade',
  data() {
    const lists: Array<object> = [];
    return {
      list: lists,
      isSelected: 0,
    };
  },
  mounted() {
    this.getDataConfForSaas();
  },
  components: {
  },
  methods: {
    chooseLevel(index: number) {
      this.isSelected = index;
      this.$emit('selectedByValue', this.list[index]);
    },
    getDataConfForSaas() {
      interface Data{
        data: [];
        success: boolean;
        message: string;
      }
      commonApi.getDataConfForSaas({ })
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
            interface SData{
              createAccount: string;
              id: number;
              key: string;
              name: string;
              remark: string;
              sort: number;
              type: string;
              typeName: string;
              updateAccount: string;
              value: string;
            }
            data.forEach((element: SData) => {
              this.list.push(element);
            });
            this.chooseLevel(0);
          } else {
          // this.error(message);
            console.log(message);
          }
        });
    },
  },
});
</script>
<style lang="stylus" scoped>
    .sale-box
      margin: 0 auto;
      display: flex;
      width: 1100px;
      .selected
        background #3281DD
        border-radius 20px
        width 260px
        margin-right 20px
        .title
          font-size 24px
          color #fff
          margin-bottom 40px
        .img-box
          width 100%
          height 300px
        .price
          font-size 30px
          color #fff
          margin-bottom 0
      .box
        border-radius 20px
        width 260px
        margin-right 20px
        .title
          font-size 24px
          color #073D7D
          margin-bottom 40px
        .img-box
          width 100%
          height 300px
        .price
          font-size 30px
          color #FF0018
          margin-bottom 0
</style>
